import { createUseStyles } from 'react-jss'
import { colors } from '../../variables.style'
import { REPORT_VIEWERS } from '../constants'

const DEFAULT_PAGE_WIDTH = 1024
const CONTAINER_PADDING = 15

export const style = {
  container: {
    width: ({ width }) => (width || DEFAULT_PAGE_WIDTH) + (2 * CONTAINER_PADDING),
    padding: CONTAINER_PADDING,
    position: 'relative',
    '&:hover $commentIcon': {
      visibility: 'visible'
    },
    '&.highlight': {
      border: `1px solid ${colors.borderGray}`,
      boxShadow: `2px 2px 2px ${colors.borderGray}`
    }
  },
  previewMode: {
    padding: 0
  },
  commentIcon: {
    composes: 'font-icon-chat-bubbles',
    fontSize: 20,
    color: colors.metallicSeaweed,
    position: 'absolute',
    top: -5,
    right: -5,
    visibility: 'hidden',
    cursor: 'pointer'
  },
  title: {
    composes: 'h3',
    textTransform: 'uppercase',
    marginTop: (props) => props.viewer === REPORT_VIEWERS.EXECUTIVE_SUMMARY_PAGE ? 0 : 40,
    marginBottom: 24,
    textAlign: 'center'
  },
  description: {
    margin: '0 auto 15px auto',
    maxWidth: 600
  },
  caption: {
    maxWidth: 1024,
    borderTop: `1px solid ${colors.borderGray}`,
    padding: '10px 0',
    marginTop: 10
  },
  captionText: {
    fontSize: 14,
    textAlign: 'justify',
    color: colors.textGray
  },
  splitChartFilterContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    '& > *': {
      width: '50%',
      display: 'flex',
      justifyContent: 'center'
    }
  }
}

export const useStyles = createUseStyles(style)
